var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxBoldGame(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.35 5.719c-2.95 0-5.35 2.4-5.35 5.35v5.58c0 2.95 2.4 5.35 5.35 5.35h9.3c2.95 0 5.35-2.4 5.35-5.35v-5.58c0-2.95-2.4-5.35-5.35-5.35h-9.3zm8.15 5.3c.55 0 1 .45 1 1s-.45 1.01-1 1.01-1-.44-1-.99v-.02c0-.55.45-1 1-1zm-5.9 5.27c-.19 0-.38-.07-.53-.22l-1.03-1.03-.99.99c-.15.15-.34.22-.53.22s-.38-.07-.53-.22a.754.754 0 0 1 0-1.06l.99-.99-.96-.96a.754.754 0 0 1 0-1.06c.29-.29.77-.29 1.06 0l.96.96.99-.99c.29-.29.77-.29 1.06 0 .29.29.29.77 0 1.06l-.99.99 1.03 1.03c.29.29.29.77 0 1.06-.15.15-.34.22-.53.22zm2.93-2.29c0-.55.44-1 .99-1h.02c.55 0 1 .45 1 1s-.44 1-1 1c-.55 0-1.01-.45-1.01-1zm1.97 1.98v-.02c0-.55.45-1 1-1s1 .45 1 1-.44 1.01-1 1.01c-.55 0-1-.44-1-.99zm1.97-1.98c0-.55.44-1 .99-1h.02c.55 0 1 .45 1 1s-.44 1-1 1c-.55 0-1.01-.45-1.01-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.63 3.65A1.64 1.64 0 0 1 12 5.26c-.15 0-.24.1-.24.23s.1.23.23.23h-1.61c-.01-.07-.02-.15-.02-.23 0-.9.73-1.63 1.62-1.63.15 0 .25-.1.25-.23l.01-.94c.01-.38.32-.69.7-.69h.01c.39 0 .69.32.69.71l-.01.94z",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldGame);
export default __webpack_public_path__ + "static/media/vuesax-bold-game.cfc12570ea4d1aebc189ca1abb8738fb.svg";
export { ForwardRef as ReactComponent };